import {
  ListSemantic_getInstance1hx6c2zatma42 as ListSemantic_getInstance,
  HeaderSemantic_getInstance39z1p9hszg7wp as HeaderSemantic_getInstance,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  forEachById3ln6mzh4mndq4 as forEachById,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  body3i5t0n7zprpqb as body,
  centeredBody28evt7zh2q8en as centeredBody,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  boldSubTitle1bjbn9bt8inbw as boldSubTitle,
  smallBody2trfy14zwtona as smallBody,
} from '../../../theming/Titles.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  lens27v59dqa1oc3r as lens,
  lens3m3nj3zkwtu6r as lens_0,
} from '../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  LightSection_getInstance1p9fz392synu9 as LightSection_getInstance,
  get_lightSection4cpu8okr0w14 as get_lightSection,
  HorizontallyPaddedSemantic_getInstance8jqirrp2bab1 as HorizontallyPaddedSemantic_getInstance,
} from '../../../theming/sections.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Dimension__compareTo_impl_gsceod2qehgbisv77nv as Dimension__compareTo_impl_gsceod,
  Dimensions32ju1l7z4mh as Dimension,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  PaymentState_Succeeded_getInstance182gjb10iikdv as PaymentState_Succeeded_getInstance,
  Party_Client_getInstance1cdrz74lwe2vi as Party_Client_getInstance,
  Party_Contractor_getInstance2xfvwqnp35yxn as Party_Contractor_getInstance,
} from '../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  RenderSize_Numerical_getInstance1z6x2shksihh7 as RenderSize_Numerical_getInstance,
  renderToString1atd3jbop96tk as renderToString,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { DisplayableStateSemantic2q119ycceacla as DisplayableStateSemantic } from '../../../theming/states.mjs';
import {
  MonetaryValue__toStringAbsolute_impl_uovmiublgrzadk0gpl as MonetaryValue__toStringAbsolute_impl_uovmiu,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__times_impl_hlr6p72nff9ykdm2zvo as MonetaryValue__times_impl_hlr6p7,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__div_impl_3meibk3mb2kbjjy06qs as MonetaryValue__div_impl_3meibk,
} from '../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { trackWeights2d4yjn3jzod5x as trackWeights } from '../../../../utils/tables/ColumnWeights.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
  get_dp28ag147e4p5cz as get_dp,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { AppState_getInstance1lcg5jamx8e1g as AppState_getInstance } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../nav/AppDimensions.mjs';
import { lazygopf2ohairjp as lazy } from '../../../../utils/utils.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../sdk/UserSession.mjs';
import { ProjectLedgerItem1yul4cns1huli as ProjectLedgerItem } from '../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_project24re8n4hoe63y as get_project,
  get_partyq13c2hdc8rqy as get_party,
  get_created3mwbwy01g8dq as get_created,
} from '../../../../../../../crowpay-shared/com/crowpay/ProjectLedgerItemFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { andvtrcuje7baox as and } from '../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { leftExpandButton23soimuuf6gel as leftExpandButton } from '../../expansion.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../../theming/colorManagement.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import {
  FinanceTableSemantic_getInstance2sirlds87craf as FinanceTableSemantic_getInstance,
  ProjectContractorPayments2a1bksdtdzr6w as ProjectContractorPayments,
  renderContractorPaymentTable2wgebbq97b8wg as renderContractorPaymentTable,
} from '../../../screens/contractor/AvailableFunds.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { get_viewIsWide3s4g60a9e0192 as get_viewIsWide } from '../../nav/crowpay.mjs';
import { ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance } from '../../../screens/common/ProjectView.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../theming/separators.mjs';
import { space2ppi73m2qk1br as space } from '../../space.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { coerceAtLeast3jlgfquiyquc9 as coerceAtLeast } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { numberToLong2pakxeg38estk as numberToLong } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  withIndex37cl61h9v5txo as withIndex,
  toList3jhuyej2anx2q as toList,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function renderDepositTable(_this__u8e3s4, deposits) {
  var tmp = _this__u8e3s4.hbb(ListSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var $this$col = view;
  trackWeights(($this$trackWeights) => {
    var tmp = $this$col.hbb(HeaderSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_0 = $this$col;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(this_0.pc());
    var tmp0_elvis_lhs = this_0.cbb_1;
    var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
    this_0.ebb(p, view);
    view.xbm(false);
    view.jbb(view.ibb(get_centered(view), $this$trackWeights.mg6(view, 1.4)), body(view, 'SOURCE'));
    view.jbb(view.ibb(get_centered(view), $this$trackWeights.mg6(view, 1.4)), centeredBody(view, 'DATE CREDITED'));
    view.jbb(view.ibb(get_centered(view), $this$trackWeights.mg6(view, 0.8)), centeredBody(view, 'STATUS'));
    view.jbb(view.ibb(get_centered(view), $this$trackWeights.mg6(view, 0.8)), centeredBody(view, 'AMOUNT'));
    this_0.fbb(p, view);
    $this$col.jbb(tmp, view);
    var tmp_0 = $this$col.hbb(ListSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_1 = $this$col;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(this_1.pc());
    var tmp0_elvis_lhs_0 = this_1.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? this_1 : tmp0_elvis_lhs_0;
    this_1.ebb(p_0, view_0);
    view_0.xbm(true);
    var tmp_1 = view_0.ibb(shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.baj(deposits).i1()), view_0.hbb(CardSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.xbm(false);
    view_1.jbb(get_centered(view_1), body(view_1, 'No deposits have been made yet.'));
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_1, view_1);
    var tmp_2 = lens(deposits, renderDepositTable$lambda$lambda);
    var tmp_3 = renderDepositTable$lambda$lambda_0;
    forEachById(view_0, tmp_2, tmp_3, VOID, ($this$forEachById, indexed) => {
      var idx = lens(indexed, renderDepositTable$lambda$lambda$lambda);
      var log = lens(indexed, renderDepositTable$lambda$lambda$lambda_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$forEachById.pc());
      var tmp0_elvis_lhs = $this$forEachById.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$forEachById : tmp0_elvis_lhs;
      $this$forEachById.ebb(p, view);
      view.xbm(false);
      dynamicTheme(view, ($this$dynamicTheme) => ($this$dynamicTheme.baj(idx) % 2 | 0) === 0 ? CardSemantic_getInstance() : LightSection_getInstance());
      var tmp = view.ibb(get_centered(view), $this$trackWeights.ng6(view));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      view_0.jba(view_0.ob6_1.ybe(BodySemantic_getInstance()));
      var tmp_0 = KMutableProperty0();
      var tmp_1 = TextView$_get_content_$ref_4pzcwl(view_0);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(view_0));
      reactiveScope(view_0, ($this$reactiveScope) => {
        var tmp0_safe_receiver = $this$reactiveScope.baj(log).a7l_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d9l_1;
        var tmp$ret$8 = tmp1_elvis_lhs == null ? 'Online Payment' : tmp1_elvis_lhs;
        this_0.set(tmp$ret$8);
        return Unit_instance;
      });
      view.fbb(p_0, view_0);
      view.jbb(tmp, view_0);
      var tmp_2 = view.ibb(get_centered(view), $this$trackWeights.ng6(view));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_1 = view.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
      view.ebb(p_1, view_1);
      view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
      view_1.bbs(Align_Center_getInstance());
      var tmp_3 = KMutableProperty0();
      var tmp_4 = TextView$_get_content_$ref_4pzcwl_0(view_1);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_1 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb_0(view_1));
      reactiveScope(view_1, ($this$reactiveScope) => {
        // Inline function 'kotlin.let' call
        var it = $this$reactiveScope.baj(log);
        var tmp0_elvis_lhs = it.b7l_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.takeIf' call
          var this_0 = it.h7l_1;
          var tmp_0;
          if (it.y7k_1.equals(PaymentState_Succeeded_getInstance())) {
            tmp_0 = this_0;
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp0_safe_receiver = tmp;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : renderToString(tmp0_safe_receiver, RenderSize_Numerical_getInstance());
        var tmp$ret$19 = tmp1_elvis_lhs == null ? '--' : tmp1_elvis_lhs;
        this_1.set(tmp$ret$19);
        return Unit_instance;
      });
      view.fbb(p_1, view_1);
      view.jbb(tmp_2, view_1);
      var tmp_5 = view.ibb(get_centered(view), $this$trackWeights.ng6(view));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_2 = view.cbb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
      view.ebb(p_2, view_2);
      view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance()));
      view_2.bbs(Align_Center_getInstance());
      dynamicTheme(view_2, ($this$dynamicTheme) => DisplayableStateSemantic().mgt($this$dynamicTheme.baj(log).y7k_1));
      var tmp_6 = KMutableProperty0();
      var tmp_7 = TextView$_get_content_$ref_4pzcwl_1(view_2);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_2 = getPropertyCallableRef('content', 0, tmp_6, tmp_7, TextView$_set_content_$ref_pketfb_1(view_2));
      reactiveScope(view_2, ($this$reactiveScope) => {
        var tmp$ret$26 = $this$reactiveScope.baj(log).y7k_1.r9c_1;
        this_2.set(tmp$ret$26);
        return Unit_instance;
      });
      view.fbb(p_2, view_2);
      view.jbb(tmp_5, view_2);
      var tmp_8 = view.ibb(get_centered(view), $this$trackWeights.ng6(view));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_3 = view.cbb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
      view.ebb(p_3, view_3);
      view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
      view_3.bbs(Align_Center_getInstance());
      var tmp_9 = KMutableProperty0();
      var tmp_10 = TextView$_get_content_$ref_4pzcwl_2(view_3);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_3 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb_2(view_3));
      reactiveScope(view_3, ($this$reactiveScope) => {
        var tmp$ret$33 = MonetaryValue__toStringAbsolute_impl_uovmiu($this$reactiveScope.baj(log).u7k_1);
        this_3.set(tmp$ret$33);
        return Unit_instance;
      });
      view.fbb(p_3, view_3);
      view.jbb(tmp_8, view_3);
      $this$forEachById.fbb(p, view);
      return view;
    });
    this_1.fbb(p_0, view_0);
    $this$col.jbb(tmp_0, view_0);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function ledger(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  view.xbm(true);
  view.zb8(get_rem(0.5));
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Space())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view.fbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  view_1.xbm(true);
  var tmp = AppState_getInstance().mbi();
  var tmp_0 = lens_0(tmp, ledger$lambda);
  lazy(view_1, tmp_0, ($this$lazy, width) => {
    if (Dimension__compareTo_impl_gsceod(width.wb1_1, get_AppDimensions().fg2_1) > 0) {
      var tmp = $this$lazy.hbb(HorizontallyPaddedSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$lazy.pc());
      var tmp0_elvis_lhs = $this$lazy.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$lazy : tmp0_elvis_lhs;
      $this$lazy.ebb(p, view);
      view.xbm(false);
      view.zb8(get_rem_0(2));
      view.jbb(get_expanding(view), bodyBold(view, 'Cost Breakdown'));
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (Space())(view.pc(), 0.5);
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      view.fbb(p_0, view_0);
      view.jbb(get_expanding(view), bodyBold(view, 'Funds Summary'));
      $this$lazy.fbb(p, view);
      $this$lazy.jbb(tmp, view);
      var tmp_0 = get_lightSection($this$lazy);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (RowOrCol())($this$lazy.pc());
      var tmp0_elvis_lhs_1 = $this$lazy.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? $this$lazy : tmp0_elvis_lhs_1;
      $this$lazy.ebb(p_1, view_1);
      view_1.xbm(false);
      view_1.zb8(get_rem_0(2));
      get_expanding(view_1);
      ledger$_anonymous_$_anonymous_$costBreakdown_cc044r(view_1, _this__u8e3s4);
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
      Companion_getInstance();
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (Space())(view_1.pc(), 0.5);
      var tmp0_elvis_lhs_2 = view_1.cbb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
      view_1.ebb(p_2, view_2);
      view_1.fbb(p_2, view_2);
      get_expanding(view_1);
      ledger$_anonymous_$_anonymous_$fundsSummary_mjp4e7(view_1, _this__u8e3s4);
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
      Companion_getInstance();
      $this$lazy.fbb(p_1, view_1);
      $this$lazy.jbb(tmp_0, view_1);
    } else {
      bodyBold($this$lazy, 'Cost Breakdown');
      var tmp_1 = get_lightSection($this$lazy);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (Frame())($this$lazy.pc());
      var tmp0_elvis_lhs_3 = $this$lazy.cbb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? $this$lazy : tmp0_elvis_lhs_3;
      $this$lazy.ebb(p_3, view_3);
      ledger$_anonymous_$_anonymous_$costBreakdown_cc044r(view_3, _this__u8e3s4);
      $this$lazy.fbb(p_3, view_3);
      $this$lazy.jbb(tmp_1, view_3);
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_4 = new (Space())($this$lazy.pc());
      var tmp0_elvis_lhs_4 = $this$lazy.cbb_1;
      var p_4 = tmp0_elvis_lhs_4 == null ? $this$lazy : tmp0_elvis_lhs_4;
      $this$lazy.ebb(p_4, view_4);
      $this$lazy.fbb(p_4, view_4);
      bodyBold($this$lazy, 'Funds Summary');
      var tmp_2 = get_lightSection($this$lazy);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_5 = new (Frame())($this$lazy.pc());
      var tmp0_elvis_lhs_5 = $this$lazy.cbb_1;
      var p_5 = tmp0_elvis_lhs_5 == null ? $this$lazy : tmp0_elvis_lhs_5;
      $this$lazy.ebb(p_5, view_5);
      ledger$_anonymous_$_anonymous_$fundsSummary_mjp4e7(view_5, _this__u8e3s4);
      $this$lazy.fbb(p_5, view_5);
      $this$lazy.jbb(tmp_2, view_5);
    }
    return Unit_instance;
  });
  view.fbb(p_1, view_1);
  if (get_viewIsWide(view) && _this__u8e3s4.rgj().equals(ProjectLens_Contractor_getInstance())) {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    view_2.xbm(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Space())(view_2.pc(), 2.0);
    var tmp0_elvis_lhs_3 = view_2.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.ebb(p_3, view_3);
    view_2.fbb(p_3, view_3);
    var depositsExpanded = Signal().fak(true);
    var paymentsExpanded = Signal().fak(true);
    var deposits = remember(VOID, VOID, VOID, ($this$remember) => {
      var tmp = $this$remember.baj(get_session()).qfv_1;
      // Inline function 'com.lightningkite.lightningdb.condition' call
      // Inline function 'com.lightningkite.lightningdb.path' call
      // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
      var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectLedgerItem()), arrayOf([]), false));
      var tmp$ret$35 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
      // Inline function 'kotlin.let' call
      var it = new (DataClassPathSelf())(tmp$ret$35);
      var tmp_1 = and(eq(get_project(it), _this__u8e3s4.jf8()), eq(get_party(it), Party_Client_getInstance()));
      // Inline function 'com.lightningkite.lightningdb.sort' call
      // Inline function 'kotlin.apply' call
      var this_0 = new (SortBuilder())();
      // Inline function 'com.lightningkite.lightningdb.path' call
      // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
      var tmp_2 = serializerOrContextual(createKType(getKClass(ProjectLedgerItem()), arrayOf([]), false));
      var tmp$ret$40 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
      var it_0 = new (DataClassPathSelf())(tmp$ret$40);
      this_0.m4a(get_created(it_0));
      var tmp$ret$45 = this_0.o1r();
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$remember.baj(tmp.kdw(new (Query())(tmp_1, tmp$ret$45, VOID, 1000)));
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().w();
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (MonetaryValue__compareTo_impl_w7ul1r(element.u7k_1, Companion_instance.o62(0)) > 0) {
          destination.v(element);
        }
      }
      return destination;
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(view_2.pc());
    var tmp0_elvis_lhs_4 = view_2.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
    view_2.ebb(p_4, view_4);
    view_4.xbm(true);
    view_4.zb8(get_dp(3));
    leftExpandButton(view_4, depositsExpanded, false, VOID, VOID, VOID, ledger$lambda_0);
    var tmp_1 = view_4.ibb(shownWhen(view_4, VOID, ($this$shownWhen) => !$this$shownWhen.baj(depositsExpanded)), colored(view_4, AppColors_getInstance().cfz_1.xg9_1));
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (Separator())(view_4.pc());
    var tmp0_elvis_lhs_5 = view_4.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
    view_4.ebb(p_5, view_5);
    view_4.fbb(p_5, view_5);
    view_4.jbb(tmp_1, view_5);
    view_4.jbb(view_4.ibb(shownWhen(view_4, VOID, ($this$shownWhen) => $this$shownWhen.baj(depositsExpanded)), view_4.hbb(FinanceTableSemantic_getInstance())), renderDepositTable(view_4, deposits));
    view_2.fbb(p_4, view_4);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (Space())(view_2.pc(), 2.0);
    var tmp0_elvis_lhs_6 = view_2.cbb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_2 : tmp0_elvis_lhs_6;
    view_2.ebb(p_6, view_6);
    view_2.fbb(p_6, view_6);
    var ledgerItems = remember(VOID, VOID, VOID, ($this$remember) => {
      var tmp = $this$remember.baj(get_session()).qfv_1;
      // Inline function 'com.lightningkite.lightningdb.condition' call
      // Inline function 'com.lightningkite.lightningdb.path' call
      // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
      var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectLedgerItem()), arrayOf([]), false));
      var tmp$ret$59 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
      // Inline function 'kotlin.let' call
      var it = new (DataClassPathSelf())(tmp$ret$59);
      var tmp_1 = and(eq(get_project(it), _this__u8e3s4.jf8()), eq(get_party(it), Party_Contractor_getInstance()));
      // Inline function 'com.lightningkite.lightningdb.sort' call
      // Inline function 'kotlin.apply' call
      var this_0 = new (SortBuilder())();
      // Inline function 'com.lightningkite.lightningdb.path' call
      // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
      var tmp_2 = serializerOrContextual(createKType(getKClass(ProjectLedgerItem()), arrayOf([]), false));
      var tmp$ret$64 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
      var it_0 = new (DataClassPathSelf())(tmp$ret$64);
      this_0.m4a(get_created(it_0));
      var tmp$ret$69 = this_0.o1r();
      return $this$remember.baj(tmp.kdw(new (Query())(tmp_1, tmp$ret$69, VOID, 1000)));
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (RowOrCol())(view_2.pc());
    var tmp0_elvis_lhs_7 = view_2.cbb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_2 : tmp0_elvis_lhs_7;
    view_2.ebb(p_7, view_7);
    view_7.xbm(true);
    view_7.zb8(get_dp(3));
    leftExpandButton(view_7, paymentsExpanded, false, VOID, VOID, VOID, ledger$lambda_1);
    var tmp_2 = view_7.ibb(shownWhen(view_7, VOID, ($this$shownWhen) => !$this$shownWhen.baj(paymentsExpanded)), colored(view_7, AppColors_getInstance().cfz_1.xg9_1));
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (Separator())(view_7.pc());
    var tmp0_elvis_lhs_8 = view_7.cbb_1;
    var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
    view_7.ebb(p_8, view_8);
    view_7.fbb(p_8, view_8);
    view_7.jbb(tmp_2, view_8);
    var tmp_3 = view_7.ibb(shownWhen(view_7, VOID, ($this$shownWhen) => $this$shownWhen.baj(paymentsExpanded)), view_7.hbb(FinanceTableSemantic_getInstance()));
    view_7.jbb(tmp_3, renderContractorPaymentTable(view_7, remember(VOID, VOID, VOID, ($this$remember) => {
      var tmp = $this$remember.baj(_this__u8e3s4.jfy());
      var tmp_0 = $this$remember.baj(ledgerItems);
      // Inline function 'kotlin.collections.map' call
      var this_0 = $this$remember.baj(_this__u8e3s4.tgm());
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var item = _iterator__ex2g4s.o1();
        var tmp$ret$73 = item.hf9_1;
        destination.v(tmp$ret$73);
      }
      return new (ProjectContractorPayments())(tmp, tmp_0, destination);
    })));
    view_2.fbb(p_7, view_7);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (Space())(view_2.pc(), 5.0);
    var tmp0_elvis_lhs_9 = view_2.cbb_1;
    var p_9 = tmp0_elvis_lhs_9 == null ? view_2 : tmp0_elvis_lhs_9;
    view_2.ebb(p_9, view_9);
    view_2.fbb(p_9, view_9);
    view.fbb(p_2, view_2);
  }
  writer.fbb(p, view);
  return view;
}
function ledger$_anonymous_$_anonymous_$tableItem_7h97ko(_this__u8e3s4, key, description, value) {
  description = description === VOID ? null : description;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_px(0));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  var tmp = get_expanding(view_0);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl_3(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_3(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$1 = key($this$reactiveScope);
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp, view_1);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl_4(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb_4(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$9 = value($this$reactiveScope);
    this_1.set(tmp$ret$9);
    return Unit_instance;
  });
  view_0.fbb(p_2, view_2);
  view.fbb(p_0, view_0);
  greySeparator(view);
  if (!(description == null)) {
    var tmp_4 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(1.9));
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_3 = view.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
    view.ebb(p_3, view_3);
    view_3.jba(view_3.ob6_1.ybe(SmallBodySemantic_getInstance()));
    var tmp_5 = KMutableProperty0();
    var tmp_6 = TextView$_get_content_$ref_4pzcwl_5(view_3);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb_5(view_3));
    reactiveScope(view_3, ($this$reactiveScope) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      var tmp$ret$21 = '(' + description($this$reactiveScope) + ')';
      this_2.set(tmp$ret$21);
      return Unit_instance;
    });
    view.fbb(p_3, view_3);
    view.jbb(tmp_4, view_3);
  } else
    space(view, get_rem(1.5));
  _this__u8e3s4.fbb(p, view);
}
function ledger$_anonymous_$_anonymous_$tableItem$0_diho2s(_this__u8e3s4, key, description, value) {
  description = description === VOID ? null : description;
  var tmp = ($this$tableItem) => key;
  var tmp_0;
  if (description == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    var it = description;
    tmp_0 = ($this$let) => it;
  }
  return ledger$_anonymous_$_anonymous_$tableItem_7h97ko(_this__u8e3s4, tmp, tmp_0, value);
}
function ledger$_anonymous_$_anonymous_$costBreakdown_cc044r(_this__u8e3s4, $this_ledger) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_dp(0));
  ledger$_anonymous_$_anonymous_$tableItem$0_diho2s(view, 'Original Project Price', VOID, ($this$tableItem) => MonetaryValue__toString_impl_xslc77($this$tableItem.baj($this_ledger.jfy()).x7b_1));
  ledger$_anonymous_$_anonymous_$tableItem$0_diho2s(view, 'Accepted Change Amount', VOID, ($this$tableItem) => MonetaryValue__toString_impl_xslc77($this$tableItem.baj($this_ledger.jfy()).a7c_1));
  ledger$_anonymous_$_anonymous_$tableItem$0_diho2s(view, 'Credits', VOID, ($this$tableItem) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$tableItem.baj($this_ledger.tgm());
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_1 = element.hf9_1.x6k_1;
      var sum_0 = Companion_instance.p91(0n);
      var _iterator__ex2g4s_0 = this_1.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        var tmp_0 = sum_0;
        var tmp$ret$0 = element_0.a5r_1;
        sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$0);
      }
      var tmp$ret$2 = sum_0;
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$2);
    }
    var tmp$ret$3 = sum;
    return MonetaryValue__toString_impl_xslc77(tmp$ret$3);
  });
  ledger$_anonymous_$_anonymous_$tableItem$0_diho2s(view, 'Active Price', VOID, ($this$tableItem) => MonetaryValue__toString_impl_xslc77($this$tableItem.baj($this_ledger.jfy()).y7b_1));
  var tmp = ($this$tableItem) => {
    var tmp0_safe_receiver = $this$tableItem.baj($this_ledger.jfy()).j7b_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver * 100;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp = roundToInt(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    return 'Retention: ' + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) + '%';
  };
  var tmp_0 = ledger$_anonymous_$_anonymous_$costBreakdown$lambda_rrzhcw;
  ledger$_anonymous_$_anonymous_$tableItem_7h97ko(view, tmp, tmp_0, ($this$tableItem) => {
    var p = $this$tableItem.baj($this_ledger.jfy());
    var tmp0_safe_receiver = p.j7b_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = MonetaryValue__toString_impl_xslc77(MonetaryValue__times_impl_hlr6p7(p.y7b_1, tmp0_safe_receiver));
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 'N/A' : tmp1_elvis_lhs;
  });
  ledger$_anonymous_$_anonymous_$tableItem$0_diho2s(view, 'Remaining Escrow Deposits', VOID, ($this$tableItem) => {
    // Inline function 'kotlin.let' call
    var it = $this$tableItem.baj($this_ledger.jfy());
    var tmp$ret$8 = MonetaryValue__minus_impl_jw9qyp(it.y7b_1, it.c7c_1);
    return MonetaryValue__toString_impl_xslc77(coerceAtLeast(new (MonetaryValue())(tmp$ret$8), new (MonetaryValue())(Companion_instance.o62(0))).a5s_1);
  });
  _this__u8e3s4.fbb(p, view);
}
function ledger$_anonymous_$_anonymous_$fundsSummary_mjp4e7(_this__u8e3s4, $this_ledger) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_dp(0));
  ledger$_anonymous_$_anonymous_$tableItem$0_diho2s(view, 'Total Escrow Deposits', VOID, ($this$tableItem) => MonetaryValue__toString_impl_xslc77($this$tableItem.baj($this_ledger.jfy()).c7c_1));
  var tmp = ledger$_anonymous_$_anonymous_$fundsSummary$lambda_40iszu;
  var tmp_0 = ledger$_anonymous_$_anonymous_$fundsSummary$lambda_40iszu_0;
  ledger$_anonymous_$_anonymous_$tableItem_7h97ko(view, tmp, tmp_0, ($this$tableItem) => MonetaryValue__toString_impl_xslc77($this$tableItem.baj($this_ledger.jfy()).e7c_1));
  ledger$_anonymous_$_anonymous_$tableItem$0_diho2s(view, 'Escrow Balance', VOID, ($this$tableItem) => MonetaryValue__toString_impl_xslc77($this$tableItem.baj($this_ledger.jfy()).s97()));
  ledger$_anonymous_$_anonymous_$tableItem$0_diho2s(view, 'Percent Paid', VOID, ($this$tableItem) => {
    var p = $this$tableItem.baj($this_ledger.jfy());
    // Inline function 'kotlin.takeIf' call
    var this_0 = new (MonetaryValue())(p.y7b_1);
    var tmp;
    if (!(this_0.a5s_1 === Companion_instance.p91(0n))) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp_0 = tmp;
    var tmp0_safe_receiver = tmp_0 == null ? null : tmp_0.a5s_1;
    var tmp_1;
    var tmp_2 = tmp0_safe_receiver;
    if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
      tmp_1 = null;
    } else {
      var tmp_3 = tmp0_safe_receiver;
      // Inline function 'kotlin.let' call
      var it = (tmp_3 == null ? null : new (MonetaryValue())(tmp_3)).a5s_1;
      tmp_1 = MonetaryValue__div_impl_3meibk(p.e7c_1, it);
    }
    var tmp1_safe_receiver = tmp_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver * 100;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : numberToLong(tmp2_safe_receiver);
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString();
    return (tmp4_elvis_lhs == null ? '0' : tmp4_elvis_lhs) + '%';
  });
  ledger$_anonymous_$_anonymous_$tableItem$0_diho2s(view, 'Client Return', VOID, ($this$tableItem) => MonetaryValue__toString_impl_xslc77(coerceAtLeast(new (MonetaryValue())($this$tableItem.baj($this_ledger.jfy()).t97()), new (MonetaryValue())(Companion_instance.p91(0n))).a5s_1));
  ledger$_anonymous_$_anonymous_$tableItem$0_diho2s(view, 'Requested Escrow Deposits', VOID, ($this$tableItem) => MonetaryValue__toString_impl_xslc77($this$tableItem.baj($this_ledger.jfy()).p97()));
  _this__u8e3s4.fbb(p, view);
}
function renderDepositTable$lambda$lambda(list) {
  return toList(withIndex(list));
}
function renderDepositTable$lambda$lambda_0(it) {
  return it.ml_1.p7k_1;
}
function renderDepositTable$lambda$lambda$lambda(it) {
  return it.ll_1;
}
function renderDepositTable$lambda$lambda$lambda_0(it) {
  return it.ml_1;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function ledger$lambda(it) {
  return new (Dimension())(it.ebi_1);
}
function ledger$lambda_0($this$leftExpandButton) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$leftExpandButton.pc());
  var tmp0_elvis_lhs = $this$leftExpandButton.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$leftExpandButton : tmp0_elvis_lhs;
  $this$leftExpandButton.ebb(p, view);
  view.xbm(true);
  view.zb8(get_dp(3));
  view.jbb(colored(view, AppColors_getInstance().cfz_1.xg9_1), boldSubTitle(view, 'Deposits'));
  smallBody(view, 'Only visible to you');
  $this$leftExpandButton.fbb(p, view);
  return Unit_instance;
}
function ledger$lambda_1($this$leftExpandButton) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$leftExpandButton.pc());
  var tmp0_elvis_lhs = $this$leftExpandButton.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$leftExpandButton : tmp0_elvis_lhs;
  $this$leftExpandButton.ebb(p, view);
  view.xbm(true);
  view.zb8(get_dp(3));
  view.jbb(colored(view, AppColors_getInstance().cfz_1.xg9_1), boldSubTitle(view, 'Payments'));
  smallBody(view, 'Only visible to you');
  $this$leftExpandButton.fbb(p, view);
  return Unit_instance;
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function ledger$_anonymous_$_anonymous_$costBreakdown$lambda_rrzhcw($this$tableItem) {
  return 'Hold % to be collected at completion. Extra client security.';
}
function ledger$_anonymous_$_anonymous_$fundsSummary$lambda_40iszu($this$tableItem) {
  return 'Release for Contractor Collection';
}
function ledger$_anonymous_$_anonymous_$fundsSummary$lambda_40iszu_0($this$tableItem) {
  return 'Payments to the contractor from draws and/or approved work less retention.';
}
//region block: exports
export {
  ledger as ledger9gxuwjk9lhk4,
};
//endregion

//# sourceMappingURL=ledger.mjs.map
